import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Grid, Header, Modal, Radio, Segment } from 'semantic-ui-react';
import './styles.css';

const paymentTypes = [
  {
    id: 'creditCard',
    label: 'Credit Card',
    value: 'creditCard',
    width: 2,
  },
  {
    id: 'eCheck',
    label: 'Online Check',
    value: 'eCheck',
    width: 3,
  },
  {
    id: 'memberEnteredPayment',
    label: 'Secure Payment Link (Online Check or Credit Card)',
    value: 'memberEnteredPayment',
    width: 4,
  },
];

class PaymentMethodSelector extends Component {
  static propTypes = {
    fieldChangeHandler: PropTypes.func.isRequired,
    member: PropTypes.object,
    allowCCPayments: PropTypes.bool,
    allowECheckPayments: PropTypes.bool,
    pciCompliantForPayments: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { member } = props;
    if (props.pciCompliantForPayments === false) {
      delete paymentTypes[0];
      if (props.allowECheckPayments === false) {
        delete paymentTypes[1];
      }
      member.paymentMethod = 'memberEnteredPayment';
    } else {
      delete paymentTypes[2];
      if (props.allowCCPayments === false && props.allowECheckPayments === true) {
        delete paymentTypes[0];
        member.paymentMethod = 'memberEnteredPayment';
      } else if (props.allowCCPayments === true && props.allowECheckPayments === false) {
        delete paymentTypes[1];
        member.paymentMethod = 'creditCard';
      } else if (props.allowCCPayments === false && props.allowECheckPayments === false) {
        delete paymentTypes[0];
        delete paymentTypes[1];
      } else {
        member.paymentMethod = 'creditCard';
      }
    }
    this.state = {
      showECheckTerms: false,
    };
  }

  onChangeValue = (_, data) => {
    const { fieldChangeHandler } = this.props;
    const payType = paymentTypes.filter(paytype => paytype.id === data.value);
    this.setPaymentMethod(data.value);
    this.setState({
      showECheckTerms: (payType[0].value === 'eCheck'),
    });
    fieldChangeHandler(_, data);
  }

  setPaymentMethod = (payMethod) => {
    const { member } = this.props;
    member.paymentMethod = payMethod;
  }

  handleModalYes = () => {
    this.setPaymentMethod('eCheck');
    this.setState({
      showECheckTerms: false,
    });
  }

  handleModalNo = () => {
    const { fieldChangeHandler, allowCCPayments, allowECheckPayments, pciCompliantForPayments } = this.props;
    let allowECheckOnly = false;
    allowECheckOnly = (allowCCPayments === false && allowECheckPayments === true);
    if (allowECheckOnly) {
      this.setPaymentMethod('memberEnteredPayment');
    } else if (!allowECheckOnly && !pciCompliantForPayments) {
      this.setPaymentMethod('memberEnteredPayment');
    } else {
      this.setPaymentMethod('creditCard');
    }

    this.setState({
      showECheckTerms: false,
    });
    fieldChangeHandler('', '');
  }

  render() {
    const { member } = this.props;
    const { showECheckTerms } = this.state;
    let disableRadio = '';

    if (member.membershipTerm === undefined || member.membershipTerm === null || member.membershipTerm === '') {
      disableRadio = 'ALL';
    }

    if (member.optionCategory === '36') {
      disableRadio = 'eCheck';
    }

    if (this.props.pciCompliantForPayments === false) {
      disableRadio = '';
    }

    return (
      <React.Fragment>
        <Segment>
          <Header as="h4" styleName="bottomPadding">
            Payment Method
          </Header>
          <Grid styleName="bottomPadding">
            {
              paymentTypes.map(payType => (
                <Radio
                  key={payType.id}
                  label={payType.label}
                  name="paymentMethod"
                  value={payType.id}
                  checked={member.paymentMethod === payType.id}
                  disabled={disableRadio === payType.id || disableRadio === 'ALL'}
                  onChange={this.onChangeValue}
                />
              ))
            }
          </Grid>
        </Segment>
        {
          showECheckTerms &&
          <Modal
            styleName="popUp"
            open={showECheckTerms === true}
          >
            <Modal.Header>Agent/Representative must read disclosure</Modal.Header>
            <Modal.Content>
              <ul>
                <li>When you pay by check, I need to notify you that you are authorizing AARP to electronically debit your bank account by providing us some additional information, to process the transaction.</li>{/* eslint-disable-line max-len */}
                <li>Do you agree to authorize AARP to electronically debit your bank account and use your information to process the transaction?</li>{/* eslint-disable-line max-len */}
              </ul>
            </Modal.Content>
            <Modal.Actions>
              <Button
                id="payTermsYesButton"
                positive
                content="Yes"
                onClick={this.handleModalYes}
              />
              <Button
                id="payTermsNoButton"
                negative
                content="No"
                onClick={this.handleModalNo}
              />
            </Modal.Actions>
          </Modal>
        }
      </React.Fragment >
    );
  }
}

export default PaymentMethodSelector;



// WEBPACK FOOTER //
// ./src/app/components/PaymentMethods/index.js